<template>
  <div class="w-full">
    <div class="w-full overflow-auto p10 non-mobile-class" v-if="kplhData">
      <div class="w-full mb16 flex-row text-14">
        <div class="column5">No</div>
        <div class="column10">Nilai</div>
        <div class="column15">Tingkat Risiko</div>
        <div class="column15">Keterangan</div>
        <div class="column10" @click="sortDate()">
          Tgl Efektif
          <!-- <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i
          ><i class="fas fa-sort-numeric-up" v-show="!sortMode"></i> -->
        </div>
        <div class="column10" @click="sortDate2()">
          Tgl Berakhir
          <!-- <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i
          ><i class="fas fa-sort-numeric-up" v-show="!sortMode"></i> -->
        </div>
        <div class="column15">PIC</div>
        <div class="column20">Last Reviewer Name</div>
        <!-- <div class="kkd-file">Attachment</div> -->
        <!-- <div class="kkd-view"></div>
        <div class="kkd-download"></div>
        <div class="kkd-edit"></div> -->
      </div>
      <div
        class="w-full mb10 flex-row text-14"
        v-for="(list, index) in kplhData"
        :key="index"
      >
        <div class="column5">
          <div>{{ index + 1 }}</div>
        </div>
        <div class="column10">
          <div>{{ list.nilai }}</div>
        </div>
        <div class="column15">
          <div>{{ list.tingkat_resiko }}</div>
        </div>
        <div class="column15">
          <div>{{ list.keterangan }}</div>
        </div>
        <div :class="`column10 ${list.activeDate < 0 ? `text-danger` : ''}`">
          <div>{{ formatDate(list.tanggal_efektif) }}</div>
        </div>
        <div class="column10">
          <div>{{ formatDate(list.tanggal_berakhir) }}</div>
        </div>
        <div class="column15">
          <div>{{ list.pic }}</div>
        </div>
        <div class="column20">
          <div>{{ list.last_reviewer }}</div>
        </div>
        <!-- <div class="kkd-file col-elipsis all-column mr10">
          <div>
            {{
              list.attachment
                ? $linkConverter(list.attachment)
                : `KPLH Penilaian ${$get(
                    $store,
                    'state.level1.profile.nama_vendor'
                  )}`
            }}
          </div>
        </div> -->
        <!-- <div class="kkd-view" @click="viewDoc(list.attachment)" v-if="list.attachment">
            <i class="far fa-eye"></i>
          </div> -->
        <!-- <div
          class="kkd-download"
          @click="downloadDoc(list.attachment)"
          v-if="list.attachment && $get($store, 'state.permissions.50.allow')"
        >
          <i class="fas fa-download"></i>
        </div>
        <div
          class="kkd-download"
          @click="checkDocument(list.request_id)"
          v-if="list.request_id && $get($store, 'state.permissions.50.allow')"
        >
          <i class="far fa-eye"></i>
        </div>
        <div class="kkd-edit" @click="showModal(list.id)">
          <i class="far fa-edit" v-if="editingStatus && editingUser"></i>
        </div> -->
      </div>
    </div>
    <div class="w-full" v-if="kplhData">
      <div
        v-for="(item, index) in kplhData"
        :key="index"
        class="legal-document-wrapper-mobile"
      >
        <div>
          <div>Nilai: {{ item.nilai }}</div>
        </div>
        <div>
          <div>Tingkat Risiko: {{ item.tingkat_resiko }}</div>
        </div>
        <div>
          <div>Ketarangan: {{ item.keterangan }}</div>
        </div>
        <div :class="`${item.activeDate < 0 ? `text-danger` : ''}`">
          <div>Tanggal Efektif: {{ formatDate(item.tanggal_efektif) }}</div>
        </div>
        <div>
          <div>Tanggal Berakhir: {{ formatDate(item.tanggal_berakhir) }}</div>
        </div>
        <div>
          <div>PIC: {{ item.pic }}</div>
        </div>
        <div>
          <div>Last Reviewer: {{ item.last_reviewer }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  data() {
    return {
      sortMode: false,
      sortMode2: false,
      datas: [
        {
          id: 1,
          jenis: 'KPLH',
          nilai: '55',
          desc: 'Low - C',
          activeDate: '14 Oct 2020',
          endDate: '14 Oct 2022',
          pic: 'Siska',
          lastReviewer: 'Siska',
          file: 'file.pdf',
        },
      ],
    }
  },
  computed: {
    kplhData() {
      return this.$store.state.level1.kplhData
    },
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.kplh_level_1.is_open',
        0
      )
    },
    editingUser() {
      return (
        this.$get(this.$store, 'state.editingStore.kplh_level_1.user_id', '') ==
        this.$get(this.$store, 'state.userid', 0)
      )
    },
  },
  methods: {
    sortDate() {
      this.sortMode = !this.sortMode
      let order_name = 'desc'

      if (!this.sortMode) {
        order_name = 'asc'
      }

      this.$store.commit('level1/SHORT_KPLH_DATA', {
        column: 'tanggal_efektif',
        order_name,
      })
    },
    sortDate2() {
      console.log('run sort')
      this.sortMode = !this.sortMode
      let order_name = 'desc'

      if (!this.sortMode) {
        order_name = 'asc'
      }

      this.$store.commit('level1/SHORT_KPLH_DATA', {
        column: 'tanggal_berakhir',
        order_name,
      })
    },
    showModal(id) {
      this.$store.commit('modalStore/SHOW_KPLH')
      this.$store.dispatch('editStore/getKplhById', { id })
    },
    changeEditMode(id) {
      this.$store.dispatch('setEditMode', id)
    },
    viewDoc(link) {
      window.open(`${api}/file/${link}`)
    },
    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    checkDocument(id) {
      let routeData = this.$router.resolve({
        path: `/pdf/kplh-document/${id}/${this.$get(
          this.$store,
          'state.level1.profile.nama_vendor'
        )}`,
      })

      window.open(routeData.href, '_blank')
    },
  },
}
</script>
